import {chunk} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import HelpButton from 'help/HelpButton';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {FloatingPlacement, FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';

export interface StepConfigField {
  variableName: string;
  addIcon?: JSX.Element;
  editor: JSX.Element;
  infoText?: string;
}
interface StepConfigFieldsTemplateProps {
  fields: Array<StepConfigField>;
  numColumns: number;
}

function StepConfigFieldsHelpButtonOrNull({infoText}: {infoText?: string}): JSX.Element | null {
  if (infoText != null) {
    return (
      <HelpButton
        renderContent={() => <span className="u-pre-wrap u-normal-font-weight">{infoText}</span>}
        iconClassName="u-small-spacing-left"
        placement={FloatingPlacement.TOP}
        interaction={FloatingInteraction.HOVER}
      />
    );
  }
  return null;
}

// TODO(BNCH-75415): Use this component to render taggedUnion editors.
export default function StepConfigFieldsTemplate({
  fields,
  numColumns,
}: StepConfigFieldsTemplateProps): JSX.Element {
  return (
    <>
      {[...chunk(fields, numColumns)].map((rowFields, rowIndex) => (
        <Row key={rowIndex} className={css(stepConfigFieldsTemplateStyles.marginBottom)}>
          {rowFields.map(({variableName, infoText, addIcon, editor}, colIndex) => (
            <Col
              key={variableName}
              sm={12 / numColumns}
              // For two-column displays, decrease the amount of padding between the two columns by reducing
              // the padding on the right of the first column and the padding on the left of the second column
              className={css(
                numColumns === 2 && colIndex % 2 === 0 && stepConfigFieldsTemplateStyles.smallPaddingRight,
                numColumns === 2 && colIndex % 2 === 1 && stepConfigFieldsTemplateStyles.smallPaddingLeft
              )}
            >
              <div className={css(stepConfigFieldsTemplateStyles.variableHeader)}>
                <span className={css(stepConfigFieldsTemplateStyles.variableText)}>{variableName}</span>
                <StepConfigFieldsHelpButtonOrNull infoText={infoText} />
                {addIcon}
              </div>
              {editor}
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
}

/** @package */
export const stepConfigFieldsTemplateStyles = StyleSheet.create({
  variableHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 4,
  },
  variableText: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  marginBottom: {
    marginBottom: 8,
  },
  smallPaddingRight: {
    paddingRight: 8,
  },
  smallPaddingLeft: {
    paddingLeft: 8,
  },
});
